import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ErrorIcon from "@mui/icons-material/Error";
import CalculateIcon from '@mui/icons-material/Calculate';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import QuizIcon from '@mui/icons-material/Quiz';
import GavelIcon from '@mui/icons-material/Gavel';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SellIcon from '@mui/icons-material/Sell';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GradingIcon from '@mui/icons-material/Grading';
import WarningIcon from '@mui/icons-material/Warning';
import DangerousIcon from '@mui/icons-material/Dangerous';
import InventoryIcon from '@mui/icons-material/Inventory';
import { ButtonSpinnerGreen } from '../styled/CustomSpinners';

function StatusIconSuccess({ icon: Icon, ...props }) {
    return (
        <Icon color="success" {...props} />
    );
}

function StatusIconError({ icon: Icon, ...props }) {
    return (
        <Icon color="error" {...props} />
    );
}

function StatusIconWarning({ icon: Icon, ...props }) {
    return (
        <Icon color="warning" {...props} />
    );
}

export const STATUS_ICONS = {
    "pending": <ButtonSpinnerGreen />,
    "Worksheet Created - Pending Projections": <StatusIconSuccess icon={NoteAddIcon} />,
    "Worksheet Created - Pending SKU & PO Creation": <StatusIconSuccess icon={NoteAddIcon} />,
    "Approval Denied - Pending Projections": <StatusIconError icon={DangerousIcon} />,
    "Errors in Worksheet (Projections) - Pending Projections": <StatusIconWarning icon={WarningIcon} />,
    "Projections Created - Pending Net Sales": <StatusIconSuccess icon={CalculateIcon} />,
    "Errors in Worksheet (Net Sales) - Pending Net Sales": <StatusIconWarning icon={WarningIcon} />,
    "Net Sales Calculated - Pending Approval Request": <StatusIconSuccess icon={MonetizationOnIcon} />,
    "Approval Requested - Pending Purchase Approval": <StatusIconSuccess icon={QuizIcon} />,
    "Purchase Approved - Pending Vendor Confirmation": <StatusIconSuccess icon={GavelIcon} />,
    "Vendor Confirmed - Pending SKU & PO Creation": <StatusIconSuccess icon={ReceiptIcon} />,
    "Vendor Denied - Pending Projections": <StatusIconError icon={DangerousIcon} />,
    "Errors in Worksheet (SKUs & PO) - Pending SKU & PO Creation": <StatusIconWarning icon={WarningIcon} />,
    "SKUs & PO Created - Pending Tracking": <StatusIconSuccess icon={SellIcon} />,
    "Tracking Added - Pending Delivery": <StatusIconSuccess icon={LocalShippingIcon} />,
    "Order Delivered - Pending Receiving": <StatusIconSuccess icon={WarehouseIcon} />,
    "Order Received - Pending Resolution": <StatusIconSuccess icon={AssignmentTurnedInIcon} />,
    "Order Resolved - Pending Resolution Approval": <StatusIconSuccess icon={GradingIcon} />,
    "Resolution Denied - Pending Resolution": <StatusIconError icon={DangerousIcon} />,
    "Receiving Completed": <StatusIconSuccess icon={AssignmentTurnedInIcon} />,
    "Internal Error": <StatusIconError icon={ErrorIcon} />,
    "Archived": <StatusIconWarning icon={InventoryIcon} />,
};